export const BRAZILIAN_COUNCILS = [
    { value: 'CRM', label: 'CRM - Conselho Regional de Medicina' },
    { value: 'CRO', label: 'CRO - Conselho Regional de Odontologia' },
    { value: 'COREN', label: 'COREN - Conselho Regional de Enfermagem' },
    { value: 'CRF', label: 'CRF - Conselho Regional de Farmácia' },
    { value: 'CREFITO', label: 'CREFITO - Conselho Regional de Fisioterapia e Terapia Ocupacional' },
    { value: 'CRESS', label: 'CRESS - Conselho Regional de Serviço Social' },
    { value: 'CRP', label: 'CRP - Conselho Regional de Psicologia' },
    { value: 'CRN', label: 'CRN - Conselho Regional de Nutricionistas' },
    { value: 'CREF', label: 'CREF - Conselho Regional de Educação Física' },
    { value: 'CRBM', label: 'CRBM - Conselho Regional de Biomedicina' },
    { value: 'CRFA', label: 'CRFA - Conselho Regional de Fonoaudiologia' },
    { value: 'CRQ', label: 'CRQ - Conselho Regional de Química' },
    { value: 'CRMV', label: 'CRMV - Conselho Regional de Medicina Veterinária' },
    { value: 'CONTER', label: 'CONTER - Conselho Nacional de Técnicos em Radiologia' },
    { value: 'CRAS', label: 'CRAS - Conselho Regional de Assistência Social' },
    { value: 'CRBio', label: 'CRBio - Conselho Regional de Biologia' },
    { value: 'OUTRO', label: 'Outro' },
] as const

export type BrazilianCouncil = typeof BRAZILIAN_COUNCILS[number]['value']
